/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { CanvasCellPresenterBase } from "./CanvasCellPresenterBase";
import { CellModel } from "./CellModel";
import { TextCellModel } from "./TextCellModel";
import { markType } from "igniteui-react-core";
import { CanvasContentCellModelHelper } from "./CanvasContentCellModelHelper";
/**
 * @hidden
 */
var CanvasTextCellPresenter = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(CanvasTextCellPresenter, _super);
    function CanvasTextCellPresenter(a) {
        return _super.call(this, a) || this;
    }
    Object.defineProperty(CanvasTextCellPresenter.prototype, "d", {
        get: function () {
            return this.a;
        },
        enumerable: true,
        configurable: true
    });
    CanvasTextCellPresenter.prototype.b = function (a) {
        _super.prototype.b.call(this, a);
        var b = a;
        if (a.ar) {
            if (a.aw(TextCellModel.kf) || a.aw(CellModel.fe)) {
                if (b.kh != null) {
                    b.ie = b.kh;
                }
                else {
                    if (b.gh == null) {
                        b.ie = "";
                    }
                    else {
                        b.ie = b.gh.toString();
                    }
                }
                this.d.ck(b.ie);
            }
            CanvasContentCellModelHelper.a(this.a.bl, b, this.a);
        }
    };
    CanvasTextCellPresenter.$t = markType(CanvasTextCellPresenter, 'CanvasTextCellPresenter', CanvasCellPresenterBase.$);
    return CanvasTextCellPresenter;
}(CanvasCellPresenterBase));
export { CanvasTextCellPresenter };
//# sourceMappingURL=CanvasTextCellPresenter.js.map
